function tt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function je(e) {
  return e instanceof Map ? e.clear = e.delete = e.set = function() {
    throw new Error("map is read-only");
  } : e instanceof Set && (e.add = e.clear = e.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((t) => {
    const n = e[t], l = typeof n;
    (l === "object" || l === "function") && !Object.isFrozen(n) && je(n);
  }), e;
}
class ye {
  constructor(t) {
    t.data === void 0 && (t.data = {}), this.data = t.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function Se(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function B(e, ...t) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const l in e)
    n[l] = e[l];
  return t.forEach(function(l) {
    for (const m in l)
      n[m] = l[m];
  }), n;
}
const nt = "</span>", be = (e) => !!e.scope, it = (e, { prefix: t }) => {
  if (e.startsWith("language:"))
    return e.replace("language:", "language-");
  if (e.includes(".")) {
    const n = e.split(".");
    return [`${t}${n.shift()}`, ...n.map((l, m) => `${l}${"_".repeat(m + 1)}`)].join(" ");
  }
  return `${t}${e}`;
};
class rt {
  constructor(t, n) {
    this.buffer = "", this.classPrefix = n.classPrefix, t.walk(this);
  }
  addText(t) {
    this.buffer += Se(t);
  }
  openNode(t) {
    if (!be(t))
      return;
    const n = it(t.scope, { prefix: this.classPrefix });
    this.span(n);
  }
  closeNode(t) {
    be(t) && (this.buffer += nt);
  }
  value() {
    return this.buffer;
  }
  span(t) {
    this.buffer += `<span class="${t}">`;
  }
}
const xe = (e = {}) => {
  const t = { children: [] };
  return Object.assign(t, e), t;
};
class se {
  constructor() {
    this.rootNode = xe(), this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  add(t) {
    this.top.children.push(t);
  }
  openNode(t) {
    const n = xe({ scope: t });
    this.add(n), this.stack.push(n);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); )
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  walk(t) {
    return this.constructor._walk(t, this.rootNode);
  }
  static _walk(t, n) {
    return typeof n == "string" ? t.addText(n) : n.children && (t.openNode(n), n.children.forEach((l) => this._walk(t, l)), t.closeNode(n)), t;
  }
  static _collapse(t) {
    typeof t != "string" && t.children && (t.children.every((n) => typeof n == "string") ? t.children = [t.children.join("")] : t.children.forEach((n) => {
      se._collapse(n);
    }));
  }
}
class st extends se {
  constructor(t) {
    super(), this.options = t;
  }
  addText(t) {
    t !== "" && this.add(t);
  }
  startScope(t) {
    this.openNode(t);
  }
  endScope() {
    this.closeNode();
  }
  __addSublanguage(t, n) {
    const l = t.root;
    n && (l.scope = `language:${n}`), this.add(l);
  }
  toHTML() {
    return new rt(this, this.options).value();
  }
  finalize() {
    return this.closeAllNodes(), !0;
  }
}
function W(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function Ne(e) {
  return C("(?=", e, ")");
}
function at(e) {
  return C("(?:", e, ")*");
}
function ot(e) {
  return C("(?:", e, ")?");
}
function C(...e) {
  return e.map((t) => W(t)).join("");
}
function ct(e) {
  const t = e[e.length - 1];
  return typeof t == "object" && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
}
function ae(...e) {
  return "(" + (ct(e).capture ? "" : "?:") + e.map((t) => W(t)).join("|") + ")";
}
function Oe(e) {
  return new RegExp(e.toString() + "|").exec("").length - 1;
}
function lt(e, t) {
  const n = e && e.exec(t);
  return n && n.index === 0;
}
const pt = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function oe(e, { joinWith: t }) {
  let n = 0;
  return e.map((l) => {
    n += 1;
    const m = n;
    let b = W(l), o = "";
    for (; b.length > 0; ) {
      const s = pt.exec(b);
      if (!s) {
        o += b;
        break;
      }
      o += b.substring(0, s.index), b = b.substring(s.index + s[0].length), s[0][0] === "\\" && s[1] ? o += "\\" + String(Number(s[1]) + m) : (o += s[0], s[0] === "(" && n++);
    }
    return o;
  }).map((l) => `(${l})`).join(t);
}
const gt = /\b\B/, Me = "[a-zA-Z]\\w*", ce = "[a-zA-Z_]\\w*", Re = "\\b\\d+(\\.\\d+)?", Ae = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Te = "\\b(0b[01]+)", ut = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", ht = (e = {}) => {
  const t = /^#![ ]*\//;
  return e.binary && (e.begin = C(t, /.*\b/, e.binary, /\b.*/)), B({ scope: "meta", begin: t, end: /$/, relevance: 0, "on:begin": (n, l) => {
    n.index !== 0 && l.ignoreMatch();
  } }, e);
}, q = { begin: "\\\\[\\s\\S]", relevance: 0 }, dt = { scope: "string", begin: "'", end: "'", illegal: "\\n", contains: [q] }, mt = { scope: "string", begin: '"', end: '"', illegal: "\\n", contains: [q] }, ft = { begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/ }, Q = function(e, t, n = {}) {
  const l = B({ scope: "comment", begin: e, end: t, contains: [] }, n);
  l.contains.push({ scope: "doctag", begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)", end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/, excludeBegin: !0, relevance: 0 });
  const m = ae("I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
  return l.contains.push({ begin: C(/[ ]+/, "(", m, /[.]?[:]?([.][ ]|[ ])/, "){3}") }), l;
}, yt = Q("//", "$"), bt = Q("/\\*", "\\*/"), xt = Q("#", "$"), wt = { scope: "number", begin: Re, relevance: 0 }, Et = { scope: "number", begin: Ae, relevance: 0 }, kt = { scope: "number", begin: Te, relevance: 0 }, _t = { scope: "regexp", begin: /\/(?=[^/\n]*\/)/, end: /\/[gimuy]*/, contains: [q, { begin: /\[/, end: /\]/, relevance: 0, contains: [q] }] }, vt = { scope: "title", begin: Me, relevance: 0 }, jt = { scope: "title", begin: ce, relevance: 0 }, St = { begin: "\\.\\s*" + ce, relevance: 0 }, Nt = function(e) {
  return Object.assign(e, { "on:begin": (t, n) => {
    n.data._beginMatch = t[1];
  }, "on:end": (t, n) => {
    n.data._beginMatch !== t[1] && n.ignoreMatch();
  } });
};
var V = Object.freeze({ __proto__: null, APOS_STRING_MODE: dt, BACKSLASH_ESCAPE: q, BINARY_NUMBER_MODE: kt, BINARY_NUMBER_RE: Te, COMMENT: Q, C_BLOCK_COMMENT_MODE: bt, C_LINE_COMMENT_MODE: yt, C_NUMBER_MODE: Et, C_NUMBER_RE: Ae, END_SAME_AS_BEGIN: Nt, HASH_COMMENT_MODE: xt, IDENT_RE: Me, MATCH_NOTHING_RE: gt, METHOD_GUARD: St, NUMBER_MODE: wt, NUMBER_RE: Re, PHRASAL_WORDS_MODE: ft, QUOTE_STRING_MODE: mt, REGEXP_MODE: _t, RE_STARTERS_RE: ut, SHEBANG: ht, TITLE_MODE: vt, UNDERSCORE_IDENT_RE: ce, UNDERSCORE_TITLE_MODE: jt });
function Ot(e, t) {
  e.input[e.index - 1] === "." && t.ignoreMatch();
}
function Mt(e, t) {
  e.className !== void 0 && (e.scope = e.className, delete e.className);
}
function Rt(e, t) {
  t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = Ot, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
}
function At(e, t) {
  Array.isArray(e.illegal) && (e.illegal = ae(...e.illegal));
}
function Tt(e, t) {
  if (e.match) {
    if (e.begin || e.end)
      throw new Error("begin & end are not supported with match");
    e.begin = e.match, delete e.match;
  }
}
function Lt(e, t) {
  e.relevance === void 0 && (e.relevance = 1);
}
const It = (e, t) => {
  if (!e.beforeMatch)
    return;
  if (e.starts)
    throw new Error("beforeMatch cannot be used with starts");
  const n = Object.assign({}, e);
  Object.keys(e).forEach((l) => {
    delete e[l];
  }), e.keywords = n.keywords, e.begin = C(n.beforeMatch, Ne(n.begin)), e.starts = { relevance: 0, contains: [Object.assign(n, { endsParent: !0 })] }, e.relevance = 0, delete n.beforeMatch;
}, Bt = ["of", "and", "for", "in", "not", "or", "if", "then", "parent", "list", "value"], Pt = "keyword";
function Le(e, t, n = Pt) {
  const l = /* @__PURE__ */ Object.create(null);
  return typeof e == "string" ? m(n, e.split(" ")) : Array.isArray(e) ? m(n, e) : Object.keys(e).forEach(function(b) {
    Object.assign(l, Le(e[b], t, b));
  }), l;
  function m(b, o) {
    t && (o = o.map((s) => s.toLowerCase())), o.forEach(function(s) {
      const a = s.split("|");
      l[a[0]] = [b, Ht(a[0], a[1])];
    });
  }
}
function Ht(e, t) {
  return t ? Number(t) : Dt(e) ? 0 : 1;
}
function Dt(e) {
  return Bt.includes(e.toLowerCase());
}
const we = {}, D = (e) => {
}, Ee = (e, ...t) => {
}, $ = (e, t) => {
  we[`${e}/${t}`] || (we[`${e}/${t}`] = !0);
}, J = new Error();
function Ie(e, t, { key: n }) {
  let l = 0;
  const m = e[n], b = {}, o = {};
  for (let s = 1; s <= t.length; s++)
    o[s + l] = m[s], b[s + l] = !0, l += Oe(t[s - 1]);
  e[n] = o, e[n]._emit = b, e[n]._multi = !0;
}
function Ct(e) {
  if (Array.isArray(e.begin)) {
    if (e.skip || e.excludeBegin || e.returnBegin)
      throw D("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), J;
    if (typeof e.beginScope != "object" || e.beginScope === null)
      throw D("beginScope must be object"), J;
    Ie(e, e.begin, { key: "beginScope" }), e.begin = oe(e.begin, { joinWith: "" });
  }
}
function $t(e) {
  if (Array.isArray(e.end)) {
    if (e.skip || e.excludeEnd || e.returnEnd)
      throw D("skip, excludeEnd, returnEnd not compatible with endScope: {}"), J;
    if (typeof e.endScope != "object" || e.endScope === null)
      throw D("endScope must be object"), J;
    Ie(e, e.end, { key: "endScope" }), e.end = oe(e.end, { joinWith: "" });
  }
}
function Ut(e) {
  e.scope && typeof e.scope == "object" && e.scope !== null && (e.beginScope = e.scope, delete e.scope);
}
function zt(e) {
  Ut(e), typeof e.beginScope == "string" && (e.beginScope = { _wrap: e.beginScope }), typeof e.endScope == "string" && (e.endScope = { _wrap: e.endScope }), Ct(e), $t(e);
}
function Wt(e) {
  function t(o, s) {
    return new RegExp(W(o), "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (s ? "g" : ""));
  }
  class n {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    addRule(s, a) {
      a.position = this.position++, this.matchIndexes[this.matchAt] = a, this.regexes.push([a, s]), this.matchAt += Oe(s) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const s = this.regexes.map((a) => a[1]);
      this.matcherRe = t(oe(s, { joinWith: "|" }), !0), this.lastIndex = 0;
    }
    exec(s) {
      this.matcherRe.lastIndex = this.lastIndex;
      const a = this.matcherRe.exec(s);
      if (!a)
        return null;
      const f = a.findIndex((v, A) => A > 0 && v !== void 0), h = this.matchIndexes[f];
      return a.splice(0, f), Object.assign(a, h);
    }
  }
  class l {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    getMatcher(s) {
      if (this.multiRegexes[s])
        return this.multiRegexes[s];
      const a = new n();
      return this.rules.slice(s).forEach(([f, h]) => a.addRule(f, h)), a.compile(), this.multiRegexes[s] = a, a;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    addRule(s, a) {
      this.rules.push([s, a]), a.type === "begin" && this.count++;
    }
    exec(s) {
      const a = this.getMatcher(this.regexIndex);
      a.lastIndex = this.lastIndex;
      let f = a.exec(s);
      if (this.resumingScanAtSamePosition() && !(f && f.index === this.lastIndex)) {
        const h = this.getMatcher(0);
        h.lastIndex = this.lastIndex + 1, f = h.exec(s);
      }
      return f && (this.regexIndex += f.position + 1, this.regexIndex === this.count && this.considerAll()), f;
    }
  }
  function m(o) {
    const s = new l();
    return o.contains.forEach((a) => s.addRule(a.begin, { rule: a, type: "begin" })), o.terminatorEnd && s.addRule(o.terminatorEnd, { type: "end" }), o.illegal && s.addRule(o.illegal, { type: "illegal" }), s;
  }
  function b(o, s) {
    const a = o;
    if (o.isCompiled)
      return a;
    [Mt, Tt, zt, It].forEach((h) => h(o, s)), e.compilerExtensions.forEach((h) => h(o, s)), o.__beforeBegin = null, [Rt, At, Lt].forEach((h) => h(o, s)), o.isCompiled = !0;
    let f = null;
    return typeof o.keywords == "object" && o.keywords.$pattern && (o.keywords = Object.assign({}, o.keywords), f = o.keywords.$pattern, delete o.keywords.$pattern), f = f || /\w+/, o.keywords && (o.keywords = Le(o.keywords, e.case_insensitive)), a.keywordPatternRe = t(f, !0), s && (o.begin || (o.begin = /\B|\b/), a.beginRe = t(a.begin), !o.end && !o.endsWithParent && (o.end = /\B|\b/), o.end && (a.endRe = t(a.end)), a.terminatorEnd = W(a.end) || "", o.endsWithParent && s.terminatorEnd && (a.terminatorEnd += (o.end ? "|" : "") + s.terminatorEnd)), o.illegal && (a.illegalRe = t(o.illegal)), o.contains || (o.contains = []), o.contains = [].concat(...o.contains.map(function(h) {
      return qt(h === "self" ? o : h);
    })), o.contains.forEach(function(h) {
      b(h, a);
    }), o.starts && b(o.starts, s), a.matcher = m(a), a;
  }
  if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return e.classNameAliases = B(e.classNameAliases || {}), b(e);
}
function Be(e) {
  return e ? e.endsWithParent || Be(e.starts) : !1;
}
function qt(e) {
  return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
    return B(e, { variants: null }, t);
  })), e.cachedVariants ? e.cachedVariants : Be(e) ? B(e, { starts: e.starts ? B(e.starts) : null }) : Object.isFrozen(e) ? B(e) : e;
}
var Xt = "11.9.0";
class Gt extends Error {
  constructor(t, n) {
    super(t), this.name = "HTMLInjectionError", this.html = n;
  }
}
const ie = Se, ke = B, _e = Symbol("nomatch"), Kt = 7, Pe = function(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), l = [];
  let m = !0;
  const b = "Could not find the language '{}', did you forget to load/include a language module?", o = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let s = { ignoreUnescapedHTML: !1, throwUnescapedHTML: !1, noHighlightRe: /^(no-?highlight)$/i, languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i, classPrefix: "hljs-", cssSelector: "pre code", languages: null, __emitter: st };
  function a(i) {
    return s.noHighlightRe.test(i);
  }
  function f(i) {
    let p = i.className + " ";
    p += i.parentNode ? i.parentNode.className : "";
    const d = s.languageDetectRe.exec(p);
    if (d) {
      const x = L(d[1]);
      return x || (Ee(b.replace("{}", d[1])), Ee("Falling back to no-highlight mode for this block.", i)), x ? d[1] : "no-highlight";
    }
    return p.split(/\s+/).find((x) => a(x) || L(x));
  }
  function h(i, p, d) {
    let x = "", E = "";
    typeof p == "object" ? (x = i, d = p.ignoreIllegals, E = p.language) : ($("10.7.0", "highlight(lang, code, ...args) has been deprecated."), $("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), E = i, x = p), d === void 0 && (d = !0);
    const O = { code: x, language: E };
    G("before:highlight", O);
    const I = O.result ? O.result : v(O.language, O.code, d);
    return I.code = O.code, G("after:highlight", I), I;
  }
  function v(i, p, d, x) {
    const E = /* @__PURE__ */ Object.create(null);
    function O(r, c) {
      return r.keywords[c];
    }
    function I() {
      if (!g.keywords) {
        k.addText(w);
        return;
      }
      let r = 0;
      g.keywordPatternRe.lastIndex = 0;
      let c = g.keywordPatternRe.exec(w), u = "";
      for (; c; ) {
        u += w.substring(r, c.index);
        const y = R.case_insensitive ? c[0].toLowerCase() : c[0], _ = O(g, y);
        if (_) {
          const [T, Qe] = _;
          if (k.addText(u), u = "", E[y] = (E[y] || 0) + 1, E[y] <= Kt && (Z += Qe), T.startsWith("_"))
            u += c[0];
          else {
            const et = R.classNameAliases[T] || T;
            M(c[0], et);
          }
        } else
          u += c[0];
        r = g.keywordPatternRe.lastIndex, c = g.keywordPatternRe.exec(w);
      }
      u += w.substring(r), k.addText(u);
    }
    function K() {
      if (w === "")
        return;
      let r = null;
      if (typeof g.subLanguage == "string") {
        if (!t[g.subLanguage]) {
          k.addText(w);
          return;
        }
        r = v(g.subLanguage, w, !0, fe[g.subLanguage]), fe[g.subLanguage] = r._top;
      } else
        r = S(w, g.subLanguage.length ? g.subLanguage : null);
      g.relevance > 0 && (Z += r.relevance), k.__addSublanguage(r._emitter, r.language);
    }
    function j() {
      g.subLanguage != null ? K() : I(), w = "";
    }
    function M(r, c) {
      r !== "" && (k.startScope(c), k.addText(r), k.endScope());
    }
    function ue(r, c) {
      let u = 1;
      const y = c.length - 1;
      for (; u <= y; ) {
        if (!r._emit[u]) {
          u++;
          continue;
        }
        const _ = R.classNameAliases[r[u]] || r[u], T = c[u];
        _ ? M(T, _) : (w = T, I(), w = ""), u++;
      }
    }
    function he(r, c) {
      return r.scope && typeof r.scope == "string" && k.openNode(R.classNameAliases[r.scope] || r.scope), r.beginScope && (r.beginScope._wrap ? (M(w, R.classNameAliases[r.beginScope._wrap] || r.beginScope._wrap), w = "") : r.beginScope._multi && (ue(r.beginScope, c), w = "")), g = Object.create(r, { parent: { value: g } }), g;
    }
    function de(r, c, u) {
      let y = lt(r.endRe, u);
      if (y) {
        if (r["on:end"]) {
          const _ = new ye(r);
          r["on:end"](c, _), _.isMatchIgnored && (y = !1);
        }
        if (y) {
          for (; r.endsParent && r.parent; )
            r = r.parent;
          return r;
        }
      }
      if (r.endsWithParent)
        return de(r.parent, c, u);
    }
    function Fe(r) {
      return g.matcher.regexIndex === 0 ? (w += r[0], 1) : (ne = !0, 0);
    }
    function Ze(r) {
      const c = r[0], u = r.rule, y = new ye(u), _ = [u.__beforeBegin, u["on:begin"]];
      for (const T of _)
        if (T && (T(r, y), y.isMatchIgnored))
          return Fe(c);
      return u.skip ? w += c : (u.excludeBegin && (w += c), j(), !u.returnBegin && !u.excludeBegin && (w = c)), he(u, r), u.returnBegin ? 0 : c.length;
    }
    function Ve(r) {
      const c = r[0], u = p.substring(r.index), y = de(g, r, u);
      if (!y)
        return _e;
      const _ = g;
      g.endScope && g.endScope._wrap ? (j(), M(c, g.endScope._wrap)) : g.endScope && g.endScope._multi ? (j(), ue(g.endScope, r)) : _.skip ? w += c : (_.returnEnd || _.excludeEnd || (w += c), j(), _.excludeEnd && (w = c));
      do
        g.scope && k.closeNode(), !g.skip && !g.subLanguage && (Z += g.relevance), g = g.parent;
      while (g !== y.parent);
      return y.starts && he(y.starts, r), _.returnEnd ? 0 : c.length;
    }
    function Je() {
      const r = [];
      for (let c = g; c !== R; c = c.parent)
        c.scope && r.unshift(c.scope);
      r.forEach((c) => k.openNode(c));
    }
    let F = {};
    function me(r, c) {
      const u = c && c[0];
      if (w += r, u == null)
        return j(), 0;
      if (F.type === "begin" && c.type === "end" && F.index === c.index && u === "") {
        if (w += p.slice(c.index, c.index + 1), !m) {
          const y = new Error(`0 width match regex (${i})`);
          throw y.languageName = i, y.badRule = F.rule, y;
        }
        return 1;
      }
      if (F = c, c.type === "begin")
        return Ze(c);
      if (c.type === "illegal" && !d) {
        const y = new Error('Illegal lexeme "' + u + '" for mode "' + (g.scope || "<unnamed>") + '"');
        throw y.mode = g, y;
      } else if (c.type === "end") {
        const y = Ve(c);
        if (y !== _e)
          return y;
      }
      if (c.type === "illegal" && u === "")
        return 1;
      if (te > 1e5 && te > c.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return w += u, u.length;
    }
    const R = L(i);
    if (!R)
      throw D(b.replace("{}", i)), new Error('Unknown language: "' + i + '"');
    const Ye = Wt(R);
    let ee = "", g = x || Ye;
    const fe = {}, k = new s.__emitter(s);
    Je();
    let w = "", Z = 0, H = 0, te = 0, ne = !1;
    try {
      if (R.__emitTokens)
        R.__emitTokens(p, k);
      else {
        for (g.matcher.considerAll(); ; ) {
          te++, ne ? ne = !1 : g.matcher.considerAll(), g.matcher.lastIndex = H;
          const r = g.matcher.exec(p);
          if (!r)
            break;
          const c = p.substring(H, r.index), u = me(c, r);
          H = r.index + u;
        }
        me(p.substring(H));
      }
      return k.finalize(), ee = k.toHTML(), { language: i, value: ee, relevance: Z, illegal: !1, _emitter: k, _top: g };
    } catch (r) {
      if (r.message && r.message.includes("Illegal"))
        return { language: i, value: ie(p), illegal: !0, relevance: 0, _illegalBy: { message: r.message, index: H, context: p.slice(H - 100, H + 100), mode: r.mode, resultSoFar: ee }, _emitter: k };
      if (m)
        return { language: i, value: ie(p), illegal: !1, relevance: 0, errorRaised: r, _emitter: k, _top: g };
      throw r;
    }
  }
  function A(i) {
    const p = { value: ie(i), illegal: !1, relevance: 0, _top: o, _emitter: new s.__emitter(s) };
    return p._emitter.addText(i), p;
  }
  function S(i, p) {
    p = p || s.languages || Object.keys(t);
    const d = A(i), x = p.filter(L).filter(ge).map((j) => v(j, i, !1));
    x.unshift(d);
    const E = x.sort((j, M) => {
      if (j.relevance !== M.relevance)
        return M.relevance - j.relevance;
      if (j.language && M.language) {
        if (L(j.language).supersetOf === M.language)
          return 1;
        if (L(M.language).supersetOf === j.language)
          return -1;
      }
      return 0;
    }), [O, I] = E, K = O;
    return K.secondBest = I, K;
  }
  function P(i, p, d) {
    const x = p && n[p] || d;
    i.classList.add("hljs"), i.classList.add(`language-${x}`);
  }
  function N(i) {
    let p = null;
    const d = f(i);
    if (a(d) || (G("before:highlightElement", { el: i, language: d }), i.dataset.highlighted))
      return;
    if (i.children.length > 0 && (s.ignoreUnescapedHTML, s.throwUnescapedHTML))
      throw new Gt("One of your code blocks includes unescaped HTML.", i.innerHTML);
    p = i;
    const x = p.textContent, E = d ? h(x, { language: d, ignoreIllegals: !0 }) : S(x);
    i.innerHTML = E.value, i.dataset.highlighted = "yes", P(i, d, E.language), i.result = { language: E.language, re: E.relevance, relevance: E.relevance }, E.secondBest && (i.secondBest = { language: E.secondBest.language, relevance: E.secondBest.relevance }), G("after:highlightElement", { el: i, result: E, text: x });
  }
  function He(i) {
    s = ke(s, i);
  }
  const De = () => {
    X(), $("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
  };
  function Ce() {
    X(), $("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
  }
  let le = !1;
  function X() {
    if (document.readyState === "loading") {
      le = !0;
      return;
    }
    document.querySelectorAll(s.cssSelector).forEach(N);
  }
  function $e() {
    le && X();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", $e, !1);
  function Ue(i, p) {
    let d = null;
    try {
      d = p(e);
    } catch (x) {
      if (D("Language definition for '{}' could not be registered.".replace("{}", i)), m)
        D(x);
      else
        throw x;
      d = o;
    }
    d.name || (d.name = i), t[i] = d, d.rawDefinition = p.bind(null, e), d.aliases && pe(d.aliases, { languageName: i });
  }
  function ze(i) {
    delete t[i];
    for (const p of Object.keys(n))
      n[p] === i && delete n[p];
  }
  function We() {
    return Object.keys(t);
  }
  function L(i) {
    return i = (i || "").toLowerCase(), t[i] || t[n[i]];
  }
  function pe(i, { languageName: p }) {
    typeof i == "string" && (i = [i]), i.forEach((d) => {
      n[d.toLowerCase()] = p;
    });
  }
  function ge(i) {
    const p = L(i);
    return p && !p.disableAutodetect;
  }
  function qe(i) {
    i["before:highlightBlock"] && !i["before:highlightElement"] && (i["before:highlightElement"] = (p) => {
      i["before:highlightBlock"](Object.assign({ block: p.el }, p));
    }), i["after:highlightBlock"] && !i["after:highlightElement"] && (i["after:highlightElement"] = (p) => {
      i["after:highlightBlock"](Object.assign({ block: p.el }, p));
    });
  }
  function Xe(i) {
    qe(i), l.push(i);
  }
  function Ge(i) {
    const p = l.indexOf(i);
    p !== -1 && l.splice(p, 1);
  }
  function G(i, p) {
    const d = i;
    l.forEach(function(x) {
      x[d] && x[d](p);
    });
  }
  function Ke(i) {
    return $("10.7.0", "highlightBlock will be removed entirely in v12.0"), $("10.7.0", "Please use highlightElement now."), N(i);
  }
  Object.assign(e, { highlight: h, highlightAuto: S, highlightAll: X, highlightElement: N, highlightBlock: Ke, configure: He, initHighlighting: De, initHighlightingOnLoad: Ce, registerLanguage: Ue, unregisterLanguage: ze, listLanguages: We, getLanguage: L, registerAliases: pe, autoDetection: ge, inherit: ke, addPlugin: Xe, removePlugin: Ge }), e.debugMode = function() {
    m = !1;
  }, e.safeMode = function() {
    m = !0;
  }, e.versionString = Xt, e.regex = { concat: C, lookahead: Ne, either: ae, optional: ot, anyNumberOfTimes: at };
  for (const i in V)
    typeof V[i] == "object" && je(V[i]);
  return Object.assign(e, V), e;
}, z = Pe({});
z.newInstance = () => Pe({});
var Ft = z;
z.HighlightJS = z, z.default = z;
const Zt = tt(Ft), ve = {}, Vt = "hljs-";
function Jt(e) {
  const t = Zt.newInstance();
  return e && b(e), { highlight: n, highlightAuto: l, listLanguages: m, register: b, registerAlias: o, registered: s };
  function n(a, f, h) {
    const v = h || ve, A = typeof v.prefix == "string" ? v.prefix : Vt;
    if (!t.getLanguage(a))
      throw new Error("Unknown language: `" + a + "` is not registered");
    t.configure({ __emitter: Yt, classPrefix: A });
    const S = t.highlight(f, { ignoreIllegals: !0, language: a });
    if (S.errorRaised)
      throw new Error("Could not highlight with `Highlight.js`", { cause: S.errorRaised });
    const P = S._emitter.root, N = P.data;
    return N.language = S.language, N.relevance = S.relevance, P;
  }
  function l(a, f) {
    const h = (f || ve).subset || m();
    let v = -1, A = 0, S;
    for (; ++v < h.length; ) {
      const P = h[v];
      if (!t.getLanguage(P))
        continue;
      const N = n(P, a, f);
      N.data && N.data.relevance !== void 0 && N.data.relevance > A && (A = N.data.relevance, S = N);
    }
    return S || { type: "root", children: [], data: { language: void 0, relevance: A } };
  }
  function m() {
    return t.listLanguages();
  }
  function b(a, f) {
    if (typeof a == "string")
      t.registerLanguage(a, f);
    else {
      let h;
      for (h in a)
        Object.hasOwn(a, h) && t.registerLanguage(h, a[h]);
    }
  }
  function o(a, f) {
    if (typeof a == "string")
      t.registerAliases(typeof f == "string" ? f : [...f], { languageName: a });
    else {
      let h;
      for (h in a)
        if (Object.hasOwn(a, h)) {
          const v = a[h];
          t.registerAliases(typeof v == "string" ? v : [...v], { languageName: h });
        }
    }
  }
  function s(a) {
    return !!t.getLanguage(a);
  }
}
class Yt {
  constructor(t) {
    this.options = t, this.root = { type: "root", children: [], data: { language: void 0, relevance: 0 } }, this.stack = [this.root];
  }
  addText(t) {
    if (t === "")
      return;
    const n = this.stack[this.stack.length - 1], l = n.children[n.children.length - 1];
    l && l.type === "text" ? l.value += t : n.children.push({ type: "text", value: t });
  }
  startScope(t) {
    this.openNode(String(t));
  }
  endScope() {
    this.closeNode();
  }
  __addSublanguage(t, n) {
    const l = this.stack[this.stack.length - 1], m = t.root.children;
    n ? l.children.push({ type: "element", tagName: "span", properties: { className: [n] }, children: m }) : l.children.push(...m);
  }
  openNode(t) {
    const n = this, l = t.split(".").map(function(o, s) {
      return s ? o + "_".repeat(s) : n.options.classPrefix + o;
    }), m = this.stack[this.stack.length - 1], b = { type: "element", tagName: "span", properties: { className: l }, children: [] };
    m.children.push(b), this.stack.push(b);
  }
  closeNode() {
    this.stack.pop();
  }
  finalize() {
  }
  toHTML() {
    return "";
  }
}
const re = /* @__PURE__ */ new Map([["1c", async () => import("./1c-BJL8CB-d.js")], ["abnf", async () => import("./abnf-Ew837g5Q.js")], ["accesslog", async () => import("./accesslog-B6xbuX38.js")], ["actionscript", async () => import("./actionscript-DTB-v6qe.js")], ["ada", async () => import("./ada-YiA2mdRb.js")], ["angelscript", async () => import("./angelscript-C-4Gg_2h.js")], ["apache", async () => import("./apache-B94XhfRF.js")], ["applescript", async () => import("./applescript-C10oYdWy.js")], ["arcade", async () => import("./arcade-CL1cQVEf.js")], ["arduino", async () => import("./arduino-pRGUnuhU.js")], ["armasm", async () => import("./armasm-DIFlbV1E.js")], ["asciidoc", async () => import("./asciidoc-BTiXyqUs.js")], ["aspectj", async () => import("./aspectj-B6xRpTBK.js")], ["autohotkey", async () => import("./autohotkey-Df3ZiX32.js")], ["autoit", async () => import("./autoit-BBJFdU_f.js")], ["avrasm", async () => import("./avrasm-aETC5YbT.js")], ["awk", async () => import("./awk-DvGj_iUg.js")], ["axapta", async () => import("./axapta-D4p3NISG.js")], ["bash", async () => import("./bash-COO0tzw8.js")], ["basic", async () => import("./basic-Cq93W1K8.js")], ["bnf", async () => import("./bnf-DOZ-BtxE.js")], ["brainfuck", async () => import("./brainfuck-LhgEUaBA.js")], ["c", async () => import("./c-CvRZYbTW.js")], ["cal", async () => import("./cal-BxUSC3aq.js")], ["capnproto", async () => import("./capnproto-iODI-Zo1.js")], ["ceylon", async () => import("./ceylon-CHbdZZET.js")], ["clean", async () => import("./clean-B4CAapHq.js")], ["clojure-repl", async () => import("./clojure-repl-DHG8uNSa.js")], ["clojure", async () => import("./clojure-k0NeXk99.js")], ["cmake", async () => import("./cmake-BEGhKCYl.js")], ["coffeescript", async () => import("./coffeescript-BsNrXWPM.js")], ["coq", async () => import("./coq-BYmh1T-3.js")], ["cos", async () => import("./cos-BZ6H5PtU.js")], ["cpp", async () => import("./cpp-D9O43d3l.js")], ["crmsh", async () => import("./crmsh-CX4VSXoC.js")], ["crystal", async () => import("./crystal-BnwJPK6z.js")], ["csharp", async () => import("./csharp-DMDojyEq.js")], ["csp", async () => import("./csp-BLh138x8.js")], ["css", async () => import("./css-DX_3CHRi.js")], ["d", async () => import("./d-BdPETGYE.js")], ["dart", async () => import("./dart-D72IGU1E.js")], ["delphi", async () => import("./delphi-CUTYWC51.js")], ["diff", async () => import("./diff-B9sYjFkO.js")], ["django", async () => import("./django-C1h-0kSe.js")], ["dns", async () => import("./dns-DhYepfAL.js")], ["dockerfile", async () => import("./dockerfile-CxXnLvMo.js")], ["dos", async () => import("./dos-BnvkrkYH.js")], ["dsconfig", async () => import("./dsconfig-CkC5KDvu.js")], ["dts", async () => import("./dts-BnmLxWuM.js")], ["dust", async () => import("./dust-D4FDwWDA.js")], ["ebnf", async () => import("./ebnf--G-jiaeI.js")], ["elixir", async () => import("./elixir-DcWoIr2X.js")], ["elm", async () => import("./elm-DgbNXyn8.js")], ["erb", async () => import("./erb-SbsLXTK3.js")], ["erlang-repl", async () => import("./erlang-repl-CEz8iOU4.js")], ["erlang", async () => import("./erlang-Rmm2TtyC.js")], ["excel", async () => import("./excel-CGzXDNGo.js")], ["fix", async () => import("./fix-CQhWHvJk.js")], ["flix", async () => import("./flix-WofCMenv.js")], ["fortran", async () => import("./fortran-6WJ-cWxX.js")], ["fsharp", async () => import("./fsharp-Bfi6VO7z.js")], ["gams", async () => import("./gams-BLGUAUxF.js")], ["gauss", async () => import("./gauss-2k5VgKk1.js")], ["gcode", async () => import("./gcode-DY8x1tOA.js")], ["gherkin", async () => import("./gherkin-CnKontjs.js")], ["glsl", async () => import("./glsl-CQczDcN-.js")], ["gml", async () => import("./gml-CVNnSMiV.js")], ["go", async () => import("./go-DX_U4Ntc.js")], ["golo", async () => import("./golo-CRHRNDR2.js")], ["gradle", async () => import("./gradle-BHM2ug4-.js")], ["graphql", async () => import("./graphql-D86VYnRi.js")], ["groovy", async () => import("./groovy-CntdHuBx.js")], ["haml", async () => import("./haml-CzmiXS60.js")], ["handlebars", async () => import("./handlebars-CIdtLdaT.js")], ["haskell", async () => import("./haskell-Cy_xE8OY.js")], ["haxe", async () => import("./haxe-BMZfUdRC.js")], ["hsp", async () => import("./hsp-DAPu-OTX.js")], ["http", async () => import("./http-CVSY4XUk.js")], ["hy", async () => import("./hy-0kbgeS1Z.js")], ["inform7", async () => import("./inform7-CA057i3-.js")], ["ini", async () => import("./ini-BEjtAm2K.js")], ["irpf90", async () => import("./irpf90-CcAZ1K__.js")], ["isbl", async () => import("./isbl-CxojMt1v.js")], ["java", async () => import("./java-BdXCy_rL.js")], ["javascript", async () => import("./javascript-DqDg3pq0.js")], ["jboss-cli", async () => import("./jboss-cli-PP05Xp_5.js")], ["json", async () => import("./json-DeRKz7En.js")], ["julia-repl", async () => import("./julia-repl-DDTLZNDm.js")], ["julia", async () => import("./julia-D6-n1pao.js")], ["kotlin", async () => import("./kotlin-BQivqCux.js")], ["lasso", async () => import("./lasso-cfSBwM2u.js")], ["latex", async () => import("./latex-B0x2pxCy.js")], ["ldif", async () => import("./ldif-Boi34NAA.js")], ["leaf", async () => import("./leaf-DVX54WhE.js")], ["less", async () => import("./less-Dwa7NA2m.js")], ["lisp", async () => import("./lisp-Du3UFjTQ.js")], ["livecodeserver", async () => import("./livecodeserver-26Vmjg04.js")], ["livescript", async () => import("./livescript-18F6eiz3.js")], ["llvm", async () => import("./llvm-DPaC6ygF.js")], ["lsl", async () => import("./lsl-BcDHGTfc.js")], ["lua", async () => import("./lua-BMzHN9P8.js")], ["makefile", async () => import("./makefile-Cs8b7G35.js")], ["markdown", async () => import("./markdown-u6CrQMwo.js")], ["mathematica", async () => import("./mathematica-Wboa7Y_R.js")], ["matlab", async () => import("./matlab-BCSy1D0j.js")], ["maxima", async () => import("./maxima-D3fOKzKo.js")], ["mel", async () => import("./mel-CS8VWUfP.js")], ["mercury", async () => import("./mercury-DabdbvSG.js")], ["mipsasm", async () => import("./mipsasm-BWCgt1Ci.js")], ["mizar", async () => import("./mizar-DfEJlhJf.js")], ["mojolicious", async () => import("./mojolicious-DrXFvu0h.js")], ["monkey", async () => import("./monkey-SsGydtf_.js")], ["moonscript", async () => import("./moonscript-BoupsbSc.js")], ["n1ql", async () => import("./n1ql-Bly-SRyt.js")], ["nestedtext", async () => import("./nestedtext-twyLgjHW.js")], ["nginx", async () => import("./nginx-CkJ2YDAx.js")], ["nim", async () => import("./nim-DJJzaDL-.js")], ["nix", async () => import("./nix-B75BvVYv.js")], ["node-repl", async () => import("./node-repl-CEeyuuuI.js")], ["nsis", async () => import("./nsis-BWGZ7Hw9.js")], ["objectivec", async () => import("./objectivec-B4BMfaOa.js")], ["ocaml", async () => import("./ocaml-CpFASGno.js")], ["openscad", async () => import("./openscad-Bua9HcFw.js")], ["oxygene", async () => import("./oxygene-Pq8tYaWX.js")], ["parser3", async () => import("./parser3-CPoTa3wZ.js")], ["perl", async () => import("./perl-DBw8xtBU.js")], ["pf", async () => import("./pf-DOqA_QNz.js")], ["pgsql", async () => import("./pgsql-BOCNdeTc.js")], ["php-template", async () => import("./php-template-ChNzUQn4.js")], ["php", async () => import("./php-USqvf137.js")], ["plaintext", async () => import("./plaintext-BhRZSJWt.js")], ["pony", async () => import("./pony-BwTbVSXi.js")], ["powershell", async () => import("./powershell-D3b0AOrt.js")], ["processing", async () => import("./processing-B4DHajqW.js")], ["profile", async () => import("./profile-fC0uf2qo.js")], ["prolog", async () => import("./prolog-Bfks4QYl.js")], ["properties", async () => import("./properties-Dt5OCcZ8.js")], ["protobuf", async () => import("./protobuf-CSWf-_aD.js")], ["puppet", async () => import("./puppet-C_Lb_-2H.js")], ["purebasic", async () => import("./purebasic-DhnQEA18.js")], ["python-repl", async () => import("./python-repl-C_iGk-qc.js")], ["python", async () => import("./python-CplbB-O1.js")], ["q", async () => import("./q-CCWSmPK7.js")], ["qml", async () => import("./qml-BJNvDvIW.js")], ["r", async () => import("./r-DdQ5mqfu.js")], ["reasonml", async () => import("./reasonml-Djchccj3.js")], ["rib", async () => import("./rib-CBa_zhmM.js")], ["roboconf", async () => import("./roboconf-MeA7VUGb.js")], ["routeros", async () => import("./routeros-De-x0Gsf.js")], ["rsl", async () => import("./rsl-730fp--P.js")], ["ruby", async () => import("./ruby-DQcr7Psk.js")], ["ruleslanguage", async () => import("./ruleslanguage-BWD3Nocl.js")], ["rust", async () => import("./rust-DOZG42vu.js")], ["sas", async () => import("./sas--1ri7oJE.js")], ["scala", async () => import("./scala-BYZXONJb.js")], ["scheme", async () => import("./scheme-D1uB3-yf.js")], ["scilab", async () => import("./scilab-DWriG66l.js")], ["scss", async () => import("./scss-DonhzfBU.js")], ["shell", async () => import("./shell-BY_ftegi.js")], ["smali", async () => import("./smali-BrWUfaeG.js")], ["smalltalk", async () => import("./smalltalk-DgU3yPGG.js")], ["sml", async () => import("./sml-BsAUk2Hr.js")], ["sqf", async () => import("./sqf-NfOGijcj.js")], ["sql", async () => import("./sql-zz9rIBVk.js")], ["stan", async () => import("./stan-B-mlERin.js")], ["stata", async () => import("./stata-dPC_kCxQ.js")], ["step21", async () => import("./step21-v5ayEXTe.js")], ["stylus", async () => import("./stylus-BDmt6KDy.js")], ["subunit", async () => import("./subunit-ColeDxRA.js")], ["swift", async () => import("./swift-C9Qc6TVS.js")], ["taggerscript", async () => import("./taggerscript-C7kXesiH.js")], ["tap", async () => import("./tap-DW6VILrw.js")], ["tcl", async () => import("./tcl-CumDKLKU.js")], ["thrift", async () => import("./thrift-K8FUI8mk.js")], ["tp", async () => import("./tp-sCoL7RJl.js")], ["twig", async () => import("./twig-0O6XC6jD.js")], ["typescript", async () => import("./typescript-DEN8KsHP.js")], ["vala", async () => import("./vala-CD01RQL9.js")], ["vbnet", async () => import("./vbnet-DNzbZQTq.js")], ["vbscript-html", async () => import("./vbscript-html-BgYBJ8gW.js")], ["vbscript", async () => import("./vbscript-vXqkOS7j.js")], ["verilog", async () => import("./verilog-CLDFjDRK.js")], ["vhdl", async () => import("./vhdl-FNqnnMX7.js")], ["vim", async () => import("./vim-deDbL0Fz.js")], ["wasm", async () => import("./wasm-Hja9vE_t.js")], ["wren", async () => import("./wren-CFPL6FMt.js")], ["x86asm", async () => import("./x86asm-GDvpEz3f.js")], ["xl", async () => import("./xl-DaC4Jr4S.js")], ["xml", async () => import("./xml-DnbDM6Ru.js")], ["xquery", async () => import("./xquery-Bce8W1pE.js")], ["yaml", async () => import("./yaml-GGHnfJYO.js")], ["zephir", async () => import("./zephir-DO10f3Hy.js")]]), Qt = { apacheconf: "apache", arm: "armasm", mawk: "awk", nawk: "awk", gawk: "awk", sh: "bash", zsh: "bash", clj: "clojure", cs: "csharp", docker: "dockerfile", bat: "dos", cmd: "dos", golang: "go", h: "c", hpp: "cpp", cc: "cpp", hh: "cpp", "c++": "cpp", "h++": "cpp", cxx: "cpp", hxx: "cpp", hs: "haskell", jsp: "java", react: "javascript", js: "javascript", jsx: "javascript", mk: "makefile", mak: "makefile", make: "makefile", md: "markdown", mkdown: "markdown", mkd: "markdown", py: "python", gyp: "python", rb: "ruby", gemspec: "ruby", podspec: "ruby", thor: "ruby", irb: "ruby", rs: "rust", txt: "plaintext", text: "plaintext", ts: "typescript", tsx: "typescript", mts: "typescript", cts: "typescript", vb: "vbnet", vbs: "vbscript", yml: "yaml", html: "xml", xhtml: "xml", rss: "xml", atom: "xml", xjb: "xml", xsd: "xml", xsl: "xml", plist: "xml", svg: "xml" }, Y = Jt();
let U;
const tn = (e, t) => Y.highlight(e, t), nn = (e, t) => Y.register({ [e]: t }), rn = (e) => Qt[e] ?? e, en = (e) => (e === "javascript" || e === "typescript") && !U.has("xml"), sn = async (e) => {
  U ?? (U = /* @__PURE__ */ new Set());
  const t = re.get(e) ?? re.get("plaintext");
  if (!(U.has(e) || !t))
    if (en(e)) {
      const n = re.get("xml"), l = await Promise.allSettled([t(), n()]);
      Y.register({ [e]: l[0].value.default, xml: l[1].value.default }), U.add(e), U.add("xml");
    } else {
      const n = (await t()).default;
      Y.register({ [e]: n }), U.add(e);
    }
};
export {
  rn as getActualLanguageWithoutAlias,
  tn as parseCodeToHAST,
  nn as register,
  sn as registerLanguage
};
